module.exports = __webpack_public_path__ + "static/media/chips-paprika.ab8ef635.png";